
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-workflow-automation",
      function () {
        return require("private-next-pages/ai-workflow-automation.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-workflow-automation"])
      });
    }
  